// extracted by mini-css-extract-plugin
export var container = "_4c-0";
export var icon = "_4c-1";
export var text = "_4c-2";